/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, InputLabel, MenuItem, LinearProgress, TextField, Tabs, Tab, Switch, CircularProgress, Chip, Collapse, Paper, TableContainer, TableHead, TableRow, TableCell, TableBody, Table as MuiTable } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { colors, fonts } from '../../../utils';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { setAllDocuments } from '../../../redux/slices/shareholderRights/shareholderRights';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import { setAllWebinarsandEvents } from '../../../redux/slices/shareholderEducation/shareholderEducation';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DesktopDatePicker, LocalizationProvider, MobileDatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const styles = {
	tableHeading: {
		fontSize: '1.3rem',
		fontWeight: '700',
		fontFamily: 'poppins, sans-serif',
	},
	tableRows: {
		fontSize: '1.3rem',
		fontFamily: 'poppins, sans-serif',
	},
};


const WebinarsnEvents = () => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { webinarsandEvents } = useSelector((state) => state.shareHolderEducation);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingDoc, setIsLoadingDoc] = useState(false);
	const [tabValue, setTabValue] = useState('one');
	const [formData, setFormData] = useState({
		title: '',
		link: '',
	});
	const [webinarType, setWebinarType] = useState("Upcoming");
	const [showVideo, setShowVideo] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);

	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	const [selectedDate, setSelectedDate] = useState(dayjs());
	const [filters, setFilters] = useState({
		search: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);
	const [upcomingRows, setUpcomingRows] = useState([]);
	const [archiveRows, setArchiveRows] = useState([]);
	const [sortedData, setSortedData] = useState([]);
	const [deleteItemId, setDeleteItemId] = useState(null);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getData(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getData(currentParams.limit, 1, clearedFilters);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getData = async (limit, page, filterParams = filters) => {
		setIsLoading(true)
		try {

			await Api.post(tabValue === "one" ? endPoints?.shareHolderEducation?.fetchWebinar : endPoints?.shareHolderEducation?.fetchArchive, {
				type: "webinar",
				status: filterParams.status || "all",
				is_home: true,
				limit: limit || 50,
				page: page || 1,
				search: filterParams.search || null,
				date_from: filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
				date_to: filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					const mappedData = response?.data?.data?.shareholderss?.data?.map((d, index) => ({
						index: index + 1,
						id: d?.id,
						creator_name: d?.creator_name,
						title: d?.title,
						description: d?.description,
						url: d?.url,
						dt: d?.dt,
						is_enabled: d?.is_enabled,
						is_deleted: d?.is_deleted,
						date: d?.date,
						image: d?.image,
						ordering: d?.ordering,
					}));
					dispatch(setAllWebinarsandEvents(mappedData));
					if (tabValue === "one") {
						setUpcomingRows(mappedData);
					} else if (tabValue === "two") {
						setArchiveRows(mappedData);
					}
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.shareholderss;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)

				})
				.catch((error) => {
					setIsLoading(false);
				});
		} catch (err) {
			setIsLoading(false);
		}
	};


	const handleCreateModal = () => {
		setFormData({ title: '', description: '', url: '' })
		setOpenModal(true)
		setIsEditing(false);
	};
	const handleEditModal = (val) => {
		setFormData({ title: val.title, description: val.description, url: val.url, is_enabled: val.is_enabled, is_deleted: val.is_deleted, id: val.id, image: val.image })
		setOpenModal(true)
		setIsEditing(true);
		setSelectedDate(val.date)
	};



	const handleSubmit = async () => {
		setIsLoadingModal(true)

		if (!isEditing) {


			try {

				await Api.post(endPoints?.shareHolderEducation?.createWebinar, {
					...formData,
					type: "webinar",
					creator_id: userId,
					creator_name: fullName,
					is_home: true,
					date: selectedDate
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Webinar Created Successfully")
						setIsLoadingModal(false);

					})
					.catch((error) => {

					});

			} catch (err) {
			}

		} else {


			try {

				await Api.post(endPoints?.shareHolderEducation?.updateWebinar, {
					...formData,
					type: "webinar",
					creator_id: userId,
					creator_name: fullName,
					date: selectedDate,
					is_show_video: showVideo
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Webinar Updated Successfully")
						setIsLoadingModal(false);

					})
					.catch((error) => {

					});

			} catch (err) {
			}
		}
	};

	useEffect(() => {
		getData();
	}, [tabValue])
	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};
	const handleChangeTableSwitch = async (event, val) => {

		try {

			await Api.post(endPoints?.shareHolderEducation?.deleteWebinarStatus, {
				id: val.id,
				status: event.target.checked,
				type: "home",
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Webinar Status Updated Successfully")
					getData();

				})
				.catch((error) => {

				});

		} catch (err) {
		}

	};

	const onDragEnd = (result, isUpcoming = false) => {
		if (!result.destination) return;

		const sourceRows = isUpcoming ? upcomingRows : archiveRows;
		const updatedRows = Array.from(sourceRows);
		const [movedRow] = updatedRows.splice(result.source.index, 1);
		updatedRows.splice(result.destination.index, 0, movedRow);

		const updatedRowsWithSort = updatedRows.map((row, index) => ({
			...row,
			ordering: index
		}));

		if (isUpcoming) {
			setUpcomingRows(updatedRowsWithSort);
		} else {
			setArchiveRows(updatedRowsWithSort);
		}
		setSortedData(updatedRowsWithSort);
	};

	const handleSortSubmit = async (isUpcoming = false) => {
		const items = sortedData.map((item) => ({
			id: item.id,
			ordering: item.ordering
		}));
		const successMsg = isUpcoming
			? "Upcoming Webinars Sorting Updated Successfully"
			: "Archive Webinars Sorting Updated Successfully";

		await Api.post(endPoints?.shareHolderEducation?.updateWebinarOrder, { items }, {
			headers: {
				'xt-user-token': null
			}
		})
			.then((response) => {
				getData();
				successNotify(successMsg);
			})
			.catch((error) => {
				errorNotify("Failed to update sorting");
			});
	};

	const handleOpenDeleteModal = (id) => {
		setDeleteItemId(id);
		setOpenDeleteModal(true);
	};

	const handleCloseDeleteModal = () => {
		setDeleteItemId(null);
		setOpenDeleteModal(false);
	};

	const handleDelete = async () => {
		try {
			await Api.post(endPoints?.shareHolderEducation?.deleteWebinar, {
				id: deleteItemId,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Webinar Deleted Successfully");
					handleCloseDeleteModal();
					getData();
				})
				.catch((error) => {
					errorNotify("Failed to delete webinar");
				});
		} catch (err) {
			errorNotify("Failed to delete webinar");
		}
	};
	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully")

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');

		}
	};
	const handleChangeTab = (event, newValue) => {
		setTabValue(newValue);
	};
	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_id',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_id}</h4>,
		// },
		{
			title: 'Title',
			field: 'title',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.title?.length > 15 ?
					<ReadMoreReact
						text={rowData?.title}
						min={10}
						ideal={15}
						max={rowData?.title?.length}
						readMoreText="Read More"
					/> : rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.description?.length > 15 ?
					<ReadMoreReact
						text={rowData?.description}
						min={10}
						ideal={15}
						max={rowData?.description?.length}
						readMoreText="Read More"
					/> : rowData?.description}</h4>,
		},
		{
			title: 'Image',
			field: 'image',
			render: (rowData) =><img src={rowData?.image} height='60' width='60' />,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		// {
		// 	title: 'enabled',
		// 	field: 'is_enabled',
		// 	render: (rowData) => <h4 className='font-face-R'>{rowData?.is_enabled ? <Icon color='success' className="text-green text-16">check_circle</Icon> : <Icon className="text-red text-16">cancel</Icon>}</h4>,
		// },
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => { handleEditModal(rowData); setWebinarType("Upcoming"); }} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},

	];
	const columnArchive = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.title?.length > 15 ?
					<ReadMoreReact
						text={rowData?.title}
						min={10}
						ideal={15}
						max={rowData?.title?.length}
						readMoreText="Read More"
					/> : rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.description?.length > 15 ?
					<ReadMoreReact
						text={rowData?.description}
						min={10}
						ideal={15}
						max={rowData?.description?.length}
						readMoreText="Read More"
					/> : rowData?.description}</h4>,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => { handleEditModal(rowData); setWebinarType("Archive"); }} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},

	];

	const handleOnChangeDate = (dt) => {
		setSelectedDate(dt);
	}

	return (
		<>

			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Webinars & Events
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Title'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Flex gap='1.5rem' fw='wrap'>
								<Box sx={{ minWidth: '18rem' }}>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DesktopDatePicker
											label='Date From'
											value={filters.date_from}
											onChange={(value) => handleFilterDateChange('date_from', value)}
											renderInput={(params) => <TextField {...params} size='small' fullWidth />}
										/>
									</LocalizationProvider>
								</Box>
								<Box sx={{ minWidth: '18rem' }}>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DesktopDatePicker
											label='Date To'
											value={filters.date_to}
											onChange={(value) => handleFilterDateChange('date_to', value)}
											renderInput={(params) => <TextField {...params} size='small' fullWidth />}
										/>
									</LocalizationProvider>
								</Box>
							</Flex>

							<Flex jc='space-between' ai='center' gap='1rem' mt='1.5rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Webinar" : "Create Webinar"}
						isLoading={isLoadingModal}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.title}
									onChange={handleChange}
									// inputProps={{ maxLength: 150 }}
									label='Title'
									name='title'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.description}
									onChange={handleChange}
									// inputProps={{ maxLength: 250 }}
									label='Description'
									name='description'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.url}
									onChange={handleChange}
									label='Url'
									name='url'
								/>
							</MarginHandler>
							{isLoadingImg ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="image-upload"
										type="file"
										onChange={(event) => handleImageUpload(event)}
									/>
									<label htmlFor="image-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Image
										</Button>
									</label>
									{formData?.image &&
										<img height={100} style={{ margin: "auto" }} src={formData?.image} />
									}
								</>}
							{webinarType === "Archive" &&
								<MarginHandler>
									<FormControlLabel control={<Checkbox sx={{
										'& .MuiSvgIcon-root': { fontSize: 22 }
									}} onChange={(e) => setShowVideo(e.target.checked)} checked={showVideo} />} label="Show Video" />

								</MarginHandler>
							}

							<LocalizationProvider dateAdapter={AdapterDayjs}>

								<Box sx={{ alignItems: "center", display: "flex" }}>

									<DesktopDatePicker
										sx={{ m: "10px 10px 10px 0px" }}
										label={`Select Date`}
										value={selectedDate}
										onChange={(e) => handleOnChangeDate(e)}
										minDate={tabValue === "one" ? dayjs() : undefined}
										maxDate={tabValue === "two" ? dayjs() : undefined}
										renderInput={(params) => <TextField {...params} />}
									/>
									{/* <Button text="x" onClick={() => deleteTimePicker(index)} /> */}
								</Box>
							</LocalizationProvider>




							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										// backgroundColor: colorPrimary,
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.title}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "}
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>







				<TabContext value={tabValue}>
					<Tabs
						value={tabValue}
						onChange={handleChangeTab}
						// textColor="secondary"
						// indicatorColor="secondary"
						sx={{
							".MuiButtonBase-root": {
								fontSize: "16px",
								fontFamily: primaryFont
							}
						}}
						aria-label="secondary tabs example"
					>
						<Tab value="one" label="Upcoming Webinars & Events" />
						<Tab value="two" label="Archive Webinars & Events" />
						{/* <Tab value="four" label="Company Specific News" /> */}
					</Tabs>
					<TabPanel value="one">
						{isLoading ?
							<Box sx={{ m: '5rem' }}>
								<LinearProgress color="success" />
							</Box>
							:
							<DragDropContext onDragEnd={(result) => onDragEnd(result, true)}>
								<Droppable droppableId="droppable-upcoming" direction="vertical">
									{(provided) => (
										<TableContainer
											component={Paper}
											{...provided.droppableProps}
											ref={provided.innerRef}
										>
											<MuiTable>
												<TableHead>
													<TableRow>
														<TableCell style={styles.tableHeading}>Id</TableCell>
														<TableCell style={styles.tableHeading}>Title</TableCell>
														<TableCell style={styles.tableHeading}>Description</TableCell>
														<TableCell style={styles.tableHeading}>Image</TableCell>
														<TableCell style={styles.tableHeading}>Creator</TableCell>
														<TableCell style={styles.tableHeading}>Date</TableCell>
														<TableCell style={styles.tableHeading}>Edit</TableCell>
														<TableCell style={styles.tableHeading}>Status</TableCell>
														<TableCell style={styles.tableHeading}>Delete</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{upcomingRows.map((row, index) => (
														<Draggable key={String(row.id)} draggableId={String(row.id)} index={index}>
															{(provided) => (
																<TableRow
																	ref={provided.innerRef}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																>
																	<TableCell style={styles.tableRows}>{row?.id}</TableCell>
																	<TableCell style={styles.tableRows}>
																		{row?.title?.length > 15 ?
																			<ReadMoreReact
																				text={row?.title}
																				min={10}
																				ideal={15}
																				max={row?.title?.length}
																				readMoreText="Read More"
																			/> : row?.title}
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		{row?.description?.length > 15 ?
																			<ReadMoreReact
																				text={row?.description}
																				min={10}
																				ideal={15}
																				max={row?.description?.length}
																				readMoreText="Read More"
																			/> : row?.description}
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		{row?.image ? <img src={row?.image} height='60' width='60' style={{ objectFit: 'cover', borderRadius: '4px' }} alt="webinar" /> : '-'}
																	</TableCell>
																	<TableCell style={styles.tableRows}>{row?.creator_name}</TableCell>
																	<TableCell style={styles.tableRows}>{moment(row?.dt).format("DD-MM-YYYY")}</TableCell>
																	<TableCell style={styles.tableRows}>
																		<Tooltip title='Edit'>
																			<IconButton onClick={() => { handleEditModal(row); setWebinarType("Upcoming"); }} aria-label='Edit'>
																				<EditIcon />
																			</IconButton>
																		</Tooltip>
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, row)} checked={row?.is_enabled} name='enabled' />
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		<Tooltip title='Delete'>
																			<IconButton onClick={() => handleOpenDeleteModal(row.id)} aria-label='Delete' color='error'>
																				<DeleteIcon />
																			</IconButton>
																		</Tooltip>
																	</TableCell>
																</TableRow>
															)}
														</Draggable>
													))}
												</TableBody>
											</MuiTable>
											{provided.placeholder}
										</TableContainer>
									)}
								</Droppable>
							</DragDropContext>
						}
						<div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1em" }}>
							<ButtonCom onClickHandler={() => handleSortSubmit(true)} btnTitle={"Save Sorting"} />
						</div>
					</TabPanel>
					<TabPanel value="two">
						{isLoading ?
							<Box sx={{ m: '5rem' }}>
								<LinearProgress color="success" />
							</Box>
							:
							<DragDropContext onDragEnd={(result) => onDragEnd(result, false)}>
								<Droppable droppableId="droppable-archive" direction="vertical">
									{(provided) => (
										<TableContainer
											component={Paper}
											{...provided.droppableProps}
											ref={provided.innerRef}
										>
											<MuiTable>
												<TableHead>
													<TableRow>
														<TableCell style={styles.tableHeading}>Id</TableCell>
														<TableCell style={styles.tableHeading}>Title</TableCell>
														<TableCell style={styles.tableHeading}>Description</TableCell>
														<TableCell style={styles.tableHeading}>Image</TableCell>
														<TableCell style={styles.tableHeading}>Creator</TableCell>
														<TableCell style={styles.tableHeading}>Date</TableCell>
														<TableCell style={styles.tableHeading}>Edit</TableCell>
														<TableCell style={styles.tableHeading}>Status</TableCell>
														<TableCell style={styles.tableHeading}>Delete</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{archiveRows.map((row, index) => (
														<Draggable key={String(row.id)} draggableId={String(row.id)} index={index}>
															{(provided) => (
																<TableRow
																	ref={provided.innerRef}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																>
																	<TableCell style={styles.tableRows}>{row?.id}</TableCell>
																	<TableCell style={styles.tableRows}>
																		{row?.title?.length > 15 ?
																			<ReadMoreReact
																				text={row?.title}
																				min={10}
																				ideal={15}
																				max={row?.title?.length}
																				readMoreText="Read More"
																			/> : row?.title}
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		{row?.description?.length > 15 ?
																			<ReadMoreReact
																				text={row?.description}
																				min={10}
																				ideal={15}
																				max={row?.description?.length}
																				readMoreText="Read More"
																			/> : row?.description}
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		{row?.image ? <img src={row?.image} height='60' width='60' style={{ objectFit: 'cover', borderRadius: '4px' }} alt="webinar" /> : '-'}
																	</TableCell>
																	<TableCell style={styles.tableRows}>{row?.creator_name}</TableCell>
																	<TableCell style={styles.tableRows}>{moment(row?.dt).format("DD-MM-YYYY")}</TableCell>
																	<TableCell style={styles.tableRows}>
																		<Tooltip title='Edit'>
																			<IconButton onClick={() => { handleEditModal(row); setWebinarType("Archive"); }} aria-label='Edit'>
																				<EditIcon />
																			</IconButton>
																		</Tooltip>
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, row)} checked={row?.is_enabled} name='enabled' />
																	</TableCell>
																	<TableCell style={styles.tableRows}>
																		<Tooltip title='Delete'>
																			<IconButton onClick={() => handleOpenDeleteModal(row.id)} aria-label='Delete' color='error'>
																				<DeleteIcon />
																			</IconButton>
																		</Tooltip>
																	</TableCell>
																</TableRow>
															)}
														</Draggable>
													))}
												</TableBody>
											</MuiTable>
											{provided.placeholder}
										</TableContainer>
									)}
								</Droppable>
							</DragDropContext>
						}
						<div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1em" }}>
							<ButtonCom onClickHandler={() => handleSortSubmit(false)} btnTitle={"Save Sorting"} />
						</div>
					</TabPanel>
				</TabContext>

				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDelete}
				/>




			</Card>
		</>
	);
};

export default WebinarsnEvents;
